import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskStudentCheckStatusResultVm } from '../my-osk-student-check-status-result-vm.model';
@Injectable({ providedIn: 'root' })
export class MyOskStudentStatusService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskStudentStatus`;
  }
  get(email: string, phone: string): Observable<IMyOskStudentCheckStatusResultVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (email !== undefined && email !== null) {
      params = params.set('email', email.toString());
    }
    if (phone !== undefined && phone !== null) {
      params = params.set('phone', phone.toString());
    }
    return this.http.get<IMyOskStudentCheckStatusResultVm>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
